import {
    ADD_AUDIO_CONTROL_BLOCK,
    ADD_AUDIO_CONTROL_CONDITION,
    ARCHIVE_AUDIO_CONTROL_TABLE_TOGGLE,
    AUDIO_CONTROL_CLEAR_FILTERS,
    AUDIO_CONTROL_DIALOG_VISIBLE,
    AUDIO_CONTROL_FIELD,
    INITIAL_AUDIO_CONTROL_DATA,
    REMOVE_AUDIO_CONTROL_BLOCK,
    REMOVE_AUDIO_CONTROL_CONDITION,
    SELECTED_AUDIO_CONTROL_ID,
    SET_AUDIO_CONTROL_BLOCKS,
    SET_AUDIO_CONTROL_CURRENT_PAGE,
    SET_AUDIO_CONTROL_CURRENT_SIZE,
    SET_AUDIO_CONTROL_ERROR_FIELDS,
    SET_FAIL_LIST,
    SHOW_AUDIO_CONTROL_LOADER,
    SHOW_AUDIO_CONTROL_SAVE_LOADER,
    UPDATE_AUDIO_CONTROL_BLOCK,
    UPDATE_AUDIO_CONTROL_CONDITION,
} from "../types/typesAudioControlList";
import {
    createEmptyAudioControlBlock,
    createEmptyAudioControlCondition,
    type AudioControlFailListItem,
} from "../../components/Settings/AudioControlList/audioControlQuestionnaire";

export function setArchiveAudioControlTableToggle(state: boolean) {
    return {
        type: ARCHIVE_AUDIO_CONTROL_TABLE_TOGGLE,
        payload: state,
    }
}

export function setAudioControlDialogVisible(state: boolean) {
    return {
        type: AUDIO_CONTROL_DIALOG_VISIBLE,
        payload: state,
    }
}

export function setSelectedAudioControlIndex(state: number) {
    return {
        type: SELECTED_AUDIO_CONTROL_ID,
        payload: state,
    }
}

export function setAudioControlField(state: { fieldName: string, value: any }) {
    return {
        type: AUDIO_CONTROL_FIELD,
        payload: state,
    }
}

export function setAudioControlClearFilters() {
    return {
        type: AUDIO_CONTROL_CLEAR_FILTERS,
    }
}

export function showAudioControlLoader(state: boolean) {
    return {
        type: SHOW_AUDIO_CONTROL_LOADER,
        payload: state,
    }
}

export function showAudioControlSaveLoader(state: boolean) {
    return {
        type: SHOW_AUDIO_CONTROL_SAVE_LOADER,
        payload: state,
    }
}

export function initialAudioControlData() {
    return {
        type: INITIAL_AUDIO_CONTROL_DATA,
    }
}

export function setAudioControlErrorField(state: any) {
    return {
        type: SET_AUDIO_CONTROL_ERROR_FIELDS,
        payload: state,
    }
}

export function setAudioControlCurrentPage(state: any) {
    return {
        type: SET_AUDIO_CONTROL_CURRENT_PAGE,
        payload: state
    }
}

export function setAudioControlCurrentPageSize(state: any) {
    return {
        type: SET_AUDIO_CONTROL_CURRENT_SIZE,
        payload: state
    }
}

export function setAudioControlBlocks(blocks: unknown[]) {
    return {
        type: SET_AUDIO_CONTROL_BLOCKS,
        payload: blocks,
    }
}

export function addAudioControlBlock() {
    return {
        type: ADD_AUDIO_CONTROL_BLOCK,
        payload: createEmptyAudioControlBlock(),
    }
}

export function removeAudioControlBlock(blockIndex: number) {
    return {
        type: REMOVE_AUDIO_CONTROL_BLOCK,
        payload: blockIndex,
    }
}

export function updateAudioControlBlock(blockIndex: number, fieldName: string, value: unknown) {
    return {
        type: UPDATE_AUDIO_CONTROL_BLOCK,
        payload: {blockIndex, fieldName, value},
    }
}

export function addAudioControlCondition(blockIndex: number) {
    return {
        type: ADD_AUDIO_CONTROL_CONDITION,
        payload: {blockIndex, condition: createEmptyAudioControlCondition()},
    }
}

export function removeAudioControlCondition(blockIndex: number, conditionIndex: number) {
    return {
        type: REMOVE_AUDIO_CONTROL_CONDITION,
        payload: {blockIndex, conditionIndex},
    }
}

export function updateAudioControlCondition(
    blockIndex: number,
    conditionIndex: number,
    fieldName: string,
    value: unknown
) {
    return {
        type: UPDATE_AUDIO_CONTROL_CONDITION,
        payload: {blockIndex, conditionIndex, fieldName, value},
    }
}

export function setFailList(failList: AudioControlFailListItem[]) {
    return {
        type: SET_FAIL_LIST,
        payload: failList,
    }
}
